import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/home/HomePage';
import DownloaderPage from './pages/downloader/DownloaderPage';
import GalleryPage from './pages/gallery/GalleryPage';
import Legal from './components/Legal';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Create a dark theme instance based on X's design
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1D9BF0', // X's blue color
    },
    secondary: {
      main: '#F91880', // X's pink color
    },
    background: {
      default: '#000000', // X's background
      paper: '#16181C', // X's card background
    },
    text: {
      primary: '#E7E9EA', // X's primary text
      secondary: '#71767B', // X's secondary text
    },
  },
  typography: {
    fontFamily: '"Chirp", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '9999px', // Rounded buttons like X
          textTransform: 'none', // No uppercase text
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16, // Rounded corners for cards
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 4,
            backgroundColor: '#202327',
            '&:hover': {
              backgroundColor: '#16181C',
            },
          },
        },
      },
    },
  },
});

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/downloader" element={<DownloaderPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/:handle" element={<Navigate to="/gallery" replace />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </ThemeProvider>
    </Router>
  );
}

export default App;
